import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { AlertCircle } from 'lucide-react';
export function PainPoints() {
  const pains = ['Te inflás con facilidad (o sentís pesadez casi todos los días).', 'Llegás a la noche con cero energía y la panza “dura”.', 'Vivís en modo apuro y tu digestión lo paga.', 'Tenés una relación complicada con la comida: culpa → restricción → “me fui” → culpa.', 'Querés algo realista: sin contar calorías, sin reglas imposibles, sin sufrir.'];
  return <section className="py-24 px-4 bg-sage-50" data-id="element-118">
      <div className="max-w-3xl mx-auto" data-id="element-119">
        <FadeIn data-id="element-120">
          <h2 className="text-3xl md:text-4xl font-serif text-brown mb-12 text-center" data-id="element-121">
            Si te pasa esto, estás en el lugar correcto:
          </h2>
        </FadeIn>

        <div className="space-y-6 mb-16" data-id="element-122">
          {pains.map((pain, index) => <FadeIn key={index} delay={index * 0.1} direction="left" data-id="element-123">
              <div className="flex items-start gap-4 p-4 rounded-xl bg-white/50 border border-sage/10 hover:bg-white transition-colors duration-300" data-id="element-124">
                <div className="mt-1 min-w-[24px]" data-id="element-125">
                  <div className="w-6 h-6 rounded-full bg-sage/20 flex items-center justify-center" data-id="element-126">
                    <div className="w-2 h-2 rounded-full bg-sage" data-id="element-127" />
                  </div>
                </div>
                <p className="text-lg text-brown-light leading-relaxed" data-id="element-128">
                  {pain}
                </p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.6} className="text-center bg-white p-8 md:p-12 rounded-2xl shadow-sm border border-sage/10" data-id="element-129">
          <p className="text-2xl md:text-3xl font-serif text-terracotta mb-6" data-id="element-130">
            No estás rota. Estás saturada.
          </p>
          <p className="text-lg text-brown-light leading-relaxed max-w-2xl mx-auto" data-id="element-131">
            Y cuando el cuerpo está saturado, lo que necesita no es castigo:
            necesita <span className="font-bold text-sage" data-id="element-132">señales claras</span>
            .
          </p>
        </FadeIn>
      </div>
    </section>;
}